import React, { useState } from "react";

/**
 * Collapsible card shell shared by the report's three top-level sections, so they
 * present one header treatment: accent bar, title, supporting description and a
 * chevron that rotates with the open state.
 */
const ReportSection = ({
  title,
  subtitle,
  testId,
  defaultOpen = true,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const toggle = () => setIsOpen((open) => !open);

  return (
    <div className="ces-section" data-testid={testId}>
      <div
        className="ces-section-head"
        onClick={toggle}
        role="button"
        tabIndex={0}
        aria-expanded={isOpen}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            toggle();
          }
        }}
      >
        <span className="ces-section-title">{title}</span>
        {subtitle && <span className="ces-section-subtitle">{subtitle}</span>}
        <span
          className={`ces-section-chevron ${isOpen ? "expanded" : ""}`}
          aria-hidden="true"
        >
          &#9660;
        </span>
      </div>
      {isOpen && <div className="ces-section-body">{children}</div>}
    </div>
  );
};

export default ReportSection;
